import { Provider } from '@angular/core';
import { environment as sharedEnvironment, getEnvironmentProvider } from '@movinmotion/conf-shared';
import { environment } from '../../../environments/environment';
import merge from 'ts-deepmerge';

// ts-deepmerge ne gère pas les unions discriminantes en v6, TODO upgrade avec angular 21 pour supprimer cet override
export const mergedEnvironment = { ...merge(sharedEnvironment, environment), captcha: sharedEnvironment.captcha };

export function provideEnvironment(): Provider {
  return getEnvironmentProvider(mergedEnvironment);
}
